import React from 'react'
import { LuCircleCheckBig } from 'react-icons/lu'
import speaker from "../../../images/students/speaker.webp";

export default function Speakers() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] md:p-[40px] relative z-0 w-full overflow-hidden text-center bg-[#FFFDEB]'>
            <h3 className='text-[#101828] text-[24px] md:text-[54px] font-semibold'>Surge Speakers</h3>
            <p className='mt-[5px] md:mt-[10px] text-[#D3A600] font-normal text-[14px] md:text-[25px]'>Share your journey. Shape India’s youth.</p>
            <div className='mt-[24px] grid xl:grid-cols-2 gap-[20px] xl:gap-0 text-start'>
                <div className='border-b xl:border-b-0 xl:border-r border-[#000000] pb-[20px] md:pb-[40px] xl:pr-[40px] flex flex-col justify-center'>
                    <h5 className='text-[#080808] font-bold text-[22px] md:text-[34px]'>Why Join?</h5>
                    <div className='mt-[12px] md:mt-[24px] text-[#000000] font-noraml text-[14px] md:text-[25px]'>
                        <div className='flex gap-[10px] items-center'>
                            <LuCircleCheckBig className='text-[#00C950] text-[14px] md:text-[24px] flex-shrink-0' />
                            <p>One hour of industry experience can change a life</p>
                        </div>
                        <div className='flex gap-[10px] items-center mt-[32px]'>
                            <LuCircleCheckBig className='text-[#00C950] text-[14px] md:text-[24px] flex-shrink-0' />
                            <p>No need for perfect English or polished slides</p>
                        </div>
                        <div className='flex gap-[10px] items-center mt-[32px]'>
                            <LuCircleCheckBig className='text-[#00C950] text-[14px] md:text-[24px] flex-shrink-0 ' />
                            <p>Share practical workflows, real stories, real lessons</p>
                        </div>
                    </div>
                </div>
                <div className='pt-[20px] md:pt-[40px] xl:pl-[40px] text-center'>
                    <img src={speaker} alt='speaker' className='mx-auto size-[120px] md:size-[190px]' />
                    <div className='mt-[24px]'>
                        <h5 className='text-[#010101] font-bold text-[20px] md:text-[28px]'>Become a Surge Speaker</h5>
                        <p className='mt-[5px] text-[#99A1AF] font-noraml text-[12px] md:text-[20px]'>Takes 3 minutes to apply</p>
                    </div>
                    <button className='w-full md:w-[346px] h-[40px] md:h-[64px] mt-[12px] md:mt-[24px] rounded-[12px] bg-[#34C759] text-[#FFFFFF] text-[16px] md:text-[24px] font-semibold'>
                        Apply Now
                    </button>
                </div>
            </div>
        </div>
    )
}
